"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _sdkCore = _interopRequireWildcard(require("./sdk-core"));
var _WebServiceClient = _interopRequireDefault(require("./WebServiceClient"));
var _RegistryContract = _interopRequireDefault(require("./RegistryContract"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class WebSdk extends _sdkCore.default {
  constructor(...args) {
    super(...args);
    this._registryContract = new _RegistryContract.default(this._web3, this._networkId);
  }

  /**
   * @param {string} orgId
   * @param {string} serviceId
   * @param {string} [groupName]
   * @param {PaymentChannelManagementStrategy} [paymentChannelManagementStrategy=DefaultPaymentChannelManagementStrategy]
   * @param {ServiceClientOptions} options
   * @returns {Promise<WebServiceClient>}
   */
  async createServiceClient(orgId, serviceId, groupName = null, paymentChannelManagementStrategy = null, options = {}) {
    const serviceMetadata = await this._metadataProvider.metadata(orgId, serviceId);
    const group = await this._serviceGroup(serviceMetadata, orgId, serviceId, groupName);
    return new _WebServiceClient.default(this, orgId, serviceId, this._mpeContract, serviceMetadata, group, this._constructStrategy(paymentChannelManagementStrategy), options);
  }
  _createIdentity() {
    return new _sdkCore.WalletRPCIdentity(this._config, this._web3);
  }
  async setupAccount() {
    await this._account._identity.setupAccount();
  }
}
var _default = exports.default = WebSdk;